export default __webpack_public_path__ + "static/media/colorGame.b52332d3.PNG";